import { useTranslate } from '@refinedev/core';
import { Select, Typography, theme } from 'antd';
import type { MasterFileViewKey } from './viewQueries';
import { viewQueries } from './viewQueries';

interface MasterAssetFileViewSelectProps {
  value: MasterFileViewKey | null;
  onChange: (key: MasterFileViewKey | null) => void;
}

/** `Widok: <view>` — which predefined filter set the table shows. */
export const MasterAssetFileViewSelect = ({
  value,
  onChange,
}: MasterAssetFileViewSelectProps) => {
  const t = useTranslate();
  const { token } = theme.useToken();

  return (
    <Select<MasterFileViewKey>
      value={value ?? 'all'}
      onChange={(key) => onChange(key === 'all' ? null : key)}
      prefix={
        <Typography.Text type="secondary">
          {t('content_catalog.master_asset_files.views.label')}
        </Typography.Text>
      }
      popupMatchSelectWidth={false}
      style={{ minWidth: 220, fontWeight: token.fontWeightStrong }}
      options={viewQueries().map((v) => ({
        value: v.key,
        label: t(`content_catalog.master_asset_files.views.${v.key}`),
      }))}
    />
  );
};
